import React from 'react';

const FlexWrapper = ({ children }) => {

	return (
		<main className={ `flex-wrapper` }>
			{children}
		</main>
	);
};
export default FlexWrapper;